/**
 * will delete in favor of listing key value config
 */
export var StatusBadgeEnum;
(function (StatusBadgeEnum) {
    StatusBadgeEnum["Added"] = "Added";
    StatusBadgeEnum["Approved"] = "Approved";
    StatusBadgeEnum["Ignored"] = "Ignored";
    StatusBadgeEnum["Indeterminate"] = "...";
    StatusBadgeEnum["Live"] = "Live";
    StatusBadgeEnum["Locked"] = "Locked";
    StatusBadgeEnum["NeedsReview"] = "Needs Review";
    StatusBadgeEnum["Removed"] = "Removed";
    StatusBadgeEnum["RemovedOther"] = "Removed Other";
    StatusBadgeEnum["ReportQueue"] = "Report Queue";
    StatusBadgeEnum["Reported"] = "Reported";
    StatusBadgeEnum["Retracted"] = "Retracted";
    StatusBadgeEnum["RetractionQueue"] = "Retraction Queue";
    StatusBadgeEnum["RetractionReq"] = "Retraction Req.";
    StatusBadgeEnum["Suspect"] = "Suspect";
    StatusBadgeEnum["Undetermined"] = "Undetermined";
    StatusBadgeEnum["Frozen"] = "Frozen";
})(StatusBadgeEnum || (StatusBadgeEnum = {}));
